import type { LoyaltyBenefitDisplay } from '@/lib/loyalty-benefits'
import { TierCardHeader } from './TierCardHeader'

interface TierCardProps {
	title: string
	points: string
	glowColor: string
	iconUrl?: string
	benefits: LoyaltyBenefitDisplay[]
}

export function TierCard({ title, points, glowColor, iconUrl, benefits }: TierCardProps) {
	return (
		<div className='flex w-full flex-col overflow-hidden rounded-2xl border border-border bg-card'>
			<TierCardHeader glowColor={glowColor} iconUrl={iconUrl} title={title} />

			<div className='flex flex-col items-center gap-2 px-5 pb-4 pt-4'>
				<h3 className='text-2xl font-medium tracking-[-0.12px] text-foreground'>{title}</h3>
				<p className='text-base tracking-[-0.24px] text-subtle-foreground'>
					Points: <span className='font-semibold text-info'>{points}</span>
				</p>
			</div>

			{benefits.length > 0 ? (
				<>
					<div className='mx-5 border-t border-border' />

					<div className='flex flex-col gap-4 px-5 py-4'>
						{benefits.map((benefit) => (
							<div key={benefit.label} className='flex items-center justify-between gap-3'>
								<span className='text-base tracking-[-0.24px] text-muted-foreground'>{benefit.label}</span>
								<span className='text-right text-base font-semibold tracking-[-0.24px] text-primary'>{benefit.value}</span>
							</div>
						))}
					</div>
				</>
			) : null}
		</div>
	)
}
